import { MARKET_ID, RANK, INCREASE_TYPE } from '../common/enum';
const { useCommonApi } = require('@fegobull/webapi').use;
const request = useCommonApi('quote-rank-v2');

export default (props) => {
    // 热议榜
    const getHotRank = async () => {
        const data = {
            sort_id: props.sort_id,
            market_id: MARKET_ID[RANK.HOT][props.market],
            lang: props.language,
            count: props.count,
            platform: props.platform,
            increase_type: props.increaseType || INCREASE_TYPE.CLOSE
        };
        try {
            return await request.get('get-rank-list', data);
        } catch (err) {
            console.error('market-rank', err);
        }
    };

    // 高股息榜
    const getHotDividendsRank = async () => {
        const data = {
            market_id: MARKET_ID[RANK.HOT_DIVIDENDS][props.market],
            lang: props.language,
            count: props.count,
            increase_type: props.increaseType || INCREASE_TYPE.CLOSE
        };
        try {
            return await request.get('get-hot-dividends-rank-list', data);
        } catch (err) {
            console.error('market-rank', err);
        }
    };

    const getMarketRank = async () => {
        if (props.rankType === RANK.HOT_DIVIDENDS) {
            return await getHotDividendsRank();
        }
        return await getHotRank();
    };

    return {
        getMarketRank
    };
};
